import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

const WORDS = ["Unabhängig", "Deutschlandweit", "Transparent", "Persönlich", "Kostenlos", "Schnell", "DSGVO-konform"];

export const TrustMarquee = () => (
  <div className="bg-blue-700 border-y border-blue-600 py-6" data-testid="trust-marquee">
    <Marquee speed={35} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <div key={i} className="flex items-center gap-8 px-8">
          <span className="font-serif italic text-2xl sm:text-3xl text-white/80">{w}</span>
          <Star className="h-4 w-4 text-blue-200 fill-blue-200" />
        </div>
      ))}
    </Marquee>
  </div>
);
